import BlurCircularOutlinedIcon from '@material-ui/icons/BlurCircularOutlined';
import NotInterestedOutlinedIcon from '@material-ui/icons/NotInterestedOutlined';
import { ISupplier } from 'gen/ApiClient';
import React from 'react';

interface IProps {
	item: ISupplier;
	style?: React.CSSProperties;
}

export const SupplierListItemStatusIcon = ({ item, style }: IProps) => {
	if (item.isDeleted) {
		return <NotInterestedOutlinedIcon style={style} />;
	} else {
		return <BlurCircularOutlinedIcon style={style} />;
	}
};
